import { useEffect, useState } from "react"

import { XIcon } from "lucide-react"
import { Input, DefaultPopover, Separator, Button, FormFeedback } from "twyne-new.ui"

import { CodeEditor } from "@/components/CodeEditor"
import { formatHTML } from "@/modules/cms/views/post/components/builder/hooks/useHTML"

import { useCraftProp } from "../utils"

export default function HTMLProperty({ name }) {
  const [open, setOpen] = useState(false)
  const [html, setHtml] = useState()
  const [error, setError] = useState(false)

  const { value, setValue } = useCraftProp(name)

  useEffect(() => {
    if (html === undefined && value) {
      setHtml(value)
    }
  }, [value, html])

  const handleValidate = async () => {
    try {
      await formatHTML(html)
      setError(false)
      return true
    } catch (error) {
      setError(true)
      return false
    }
  }

  const handleChange = (value) => {
    setError(false)
    setHtml(value)
  }

  const handleApply = async () => {
    if (!await handleValidate()) {
      return;
    }
    setValue(html)
    handleClose()
  }

  const handleClose = () => {
    setOpen(false)
    setHtml()
  }

  return <>
    <Input value={value?.slice(0, 25) || ''} readOnly variant='accent' onClick={() => setOpen(true)} />
    <DefaultPopover
      trigger={<div></div>}
      triggerProps={{ asChild: true }}
      wrapperProps={{ open, onOpenChange: setOpen }}
      contentProps={{ className: 'w-[700px]', side: 'right', align: 'center' }}
    >
      <div className="flex flex-col gap-2">
        <div className='flex justify-between items-center'>
          HTML
          <XIcon size='16' className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <Separator className='m-0 my-2' />
        <CodeEditor value={html} width='100%' height='300px' language='html' onChange={handleChange} />
        {error && <FormFeedback>Invalid HTML. Please correct it before applying.</FormFeedback>}
        <div className='flex w-full gap-2 mt-2'>
          <Button block color='accent' onClick={handleApply} disabled={error}>Apply</Button>
          <Button color='neutral' variant='outline' block onClick={handleClose}>Cancel</Button>
        </div>
      </div>
    </DefaultPopover>

  </>
}
